import React from 'react';
import { campo } from '../../design';

/**
 * Toolbar única de listagem — guia visual §3b.
 * Ordem fixa: [período] [filtros] … [busca] [ações].
 * Todos os slots são opcionais; `secondRow` é a linha de ações em massa
 * (exports, botões de lote) quando não cabem na linha principal.
 */

export const ToolbarSearch: React.FC<{
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  widthClass?: string;
}> = ({ value, onChange, placeholder = 'Buscar...', widthClass = 'w-72' }) => (
  <div className="relative">
    <svg className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={e => onChange(e.target.value)}
      className={`rounded-lg pl-9 pr-8 py-2 text-sm ${widthClass} placeholder-slate-500 focus:outline-none ${campo}`}
    />
    {value && (
      <button
        onClick={() => onChange('')}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white"
        title="Limpar busca"
      >
        &times;
      </button>
    )}
  </div>
);

const ListToolbar: React.FC<{
  period?: React.ReactNode;
  filters?: React.ReactNode;
  search?: React.ReactNode;
  actions?: React.ReactNode;
  secondRow?: React.ReactNode;
}> = ({ period, filters, search, actions, secondRow }) => (
  <div className="space-y-3">
    {/* Busca à ESQUERDA, junto do período (padrão fiscal-docs): quando os
        filtros quebram de linha, ela não fica órfã na direita. Ações sempre
        ancoradas à direita pelo spacer. */}
    <div className="flex flex-wrap items-center gap-3">
      {period}
      {search}
      {filters}
      <div className="flex-1 min-w-2" />
      {actions}
    </div>
    {secondRow && <div className="flex flex-wrap items-center gap-2">{secondRow}</div>}
  </div>
);

export default ListToolbar;
